import React from "react";
import { reportClientError } from "../lib/errorReporter";

// Catches React render crashes anywhere below it, reports them to the admin
// Error Log and shows a recovery screen instead of a blank white page.
export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    reportClientError({
      kind: "react",
      message: error?.message || String(error),
      stack: error?.stack,
      componentStack: info?.componentStack,
    });
  }

  render() {
    if (!this.state.hasError) return this.props.children;
    return (
      <div
        role="alert"
        data-testid="error-boundary"
        style={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center", padding: 16 }}
      >
        <div style={{ maxWidth: 420, textAlign: "center" }}>
          <h1 style={{ fontSize: 22, marginBottom: 8 }}>Something went wrong</h1>
          <p className="text-muted" style={{ marginBottom: 20 }}>
            The problem has been reported to our team. Reloading the page usually fixes it.
          </p>
          <div style={{ display: "flex", gap: 8, justifyContent: "center" }}>
            <button type="button" className="btn btn-gold btn-sm" onClick={() => window.location.reload()}>
              Reload page
            </button>
            <a className="btn btn-ghost btn-sm" href="/">Go to home</a>
          </div>
        </div>
      </div>
    );
  }
}
